import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './SimpleModal.scss';

interface SimpleModalProps {
  header: string;
  children: React.ReactNode;
  onClose: () => void;
  className?: string;
  disableOutsideClickClose?: boolean;
}

const SimpleModal: React.FC<SimpleModalProps> = ({ header, children, onClose, className, disableOutsideClickClose }) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const handleOverlayClick = () => {
    if (!disableOutsideClickClose) {
      onClose();
    }
  };

  return createPortal(
    <div className={`simple-modal-overlay ${className ? className : ''}`} onClick={handleOverlayClick}>
      <div className='simple-modal-container' onClick={(e) => e.stopPropagation()}>
        <div className='simple-modal-header'>
          <h2>{header}</h2>
          <button className='simple-modal-close' onClick={onClose}>
            &times;
          </button>
        </div>
        <div className='simple-modal-body'>{children}</div>
      </div>
    </div>,
    document.querySelector('.outlet-container') || document.body,
  );
};

export default SimpleModal;
